import { SiInstagram, SiX, SiMeta } from "@icons-pack/react-simple-icons";
import { Link as LucideLink } from "lucide-react";
import styles from "./SocialLink.module.css";

export function SocialLink({ href }: { href: string }) {
  const url = new URL(href);
  const hostname = url.hostname.replace("www.", "");

  let icon;
  let displayText;

  if (hostname.includes("instagram.com")) {
    icon = <SiInstagram />;
    displayText = url.pathname.slice(1).replace(/\/$/, "");
  } else if (hostname.includes("twitter.com")) {
    icon = <SiX />;
    displayText = url.pathname.slice(1).replace(/\/$/, "");
  } else if (hostname.includes("facebook.com")) {
    icon = <SiMeta />;
    displayText = url.pathname.slice(1).replace(/\/$/, "");
  } else {
    icon = <LucideLink />;
    const path = url.pathname.replace(/\/$/, "");
    displayText = path === "" ? hostname : `${hostname}${path}`;
  }

  return (
    <a href={href} target="_blank" className={styles.link}>
      {icon}
      {displayText}
    </a>
  );
}
